module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figA01_profile-regression-zones-tip-root-modification.54b290e2.png";